import { client } from './../graphql/client'

export const logout = (): void => {
  client.clearStore();
  localStorage.removeItem('token')
}
